import React, { useState, useRef, useMemo } from "react";

function SearchableSelect({ value, options, onChange, placeholder = "—" }) {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);

  const filtered = useMemo(() => {
    if (!search.trim()) return options;
    const lower = search.toLowerCase();
    return options.filter((opt) => opt.toLowerCase().includes(lower));
  }, [options, search]);

  const handleSelect = (opt) => {
    onChange(opt);
    setSearch("");
    setOpen(false);
  };

  const handleInputFocus = () => {
    setOpen(true);
    setSearch("");
  };

  const handleInputChange = (e) => {
    setSearch(e.target.value);
    if (!open) setOpen(true);
  };

  const handleBlur = () => {
    setTimeout(() => {
      setOpen(false);
      setSearch("");
    }, 150);
  };

  return (
    <div className="relative w-full min-w-[110px]">
      <input
        ref={inputRef}
        value={open ? search : value || ""}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        className="w-full bg-transparent py-1.5 px-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-inset"
      />
      {open && filtered.length > 0 && (
        <div className="absolute z-50 top-full left-0 w-full max-h-[180px] overflow-auto bg-white border border-gray-200 rounded-md shadow-lg">
          {filtered.map((opt) => (
            <div
              key={opt}
              onMouseDown={(e) => { e.preventDefault(); handleSelect(opt); }}
              className="px-2 py-1.5 text-sm cursor-pointer hover:bg-gray-100"
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchableSelect;
